import { AddressDTO } from 'src/app/core/models/system/mapping/address.dto';
import { AddressesService } from 'src/app/core/services/utelize/system/mapping/addresses-service';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { CountriesService } from 'src/app/core/services/utelize/system/mapping/countries-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { WarningModalFormComponent } from '../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-address-modal-form',
  templateUrl: './address-modal-form.component.html',
  styleUrls: ['./address-modal-form.component.scss']
})

export class AddressModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() defaultCountryId: number | undefined;
  
  @Output() addressFormCancelled: EventEmitter<void>      =new EventEmitter<void>();
  @Output() dataHasBeenSaved    : EventEmitter<AddressDTO>=new EventEmitter<AddressDTO>();

  @ViewChild('addressModalForm', { static: false }) addressModalForm!: TemplateRef<void>;
  @ViewChild('warningModalForm', { static: false }) warningModalForm!: WarningModalFormComponent;
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                          
                          
  get addressSearch() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormAddress_AddressSearch, false); }
  get autofill     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormAddressAutofill,       false); }

  private address             : AddressDTO | undefined;
  private addressId           : null | number | undefined=0;
  private addressModalFormRef!: NgbModalRef;
  private countryIdData!      : IdAndDescriptionDTO[];
  private newAddress          : boolean=false;
  private selectedAddressData!: AddressDTO[];
  
  public addressForm!         : UntypedFormGroup;
  public curUser              : SystemUserDTO;
  public formSubmitted        : boolean=false;
  public formTitle            : string="Address";
  public foundAddresses       : boolean=false;

  //#region for Validators
  
  public countyMaxLength    : number=100;
  public line1MaxLength     : number=100;
  public line2MaxLength     : number=100;
  public line3MaxLength     : number=100;
  public postCodeMaxLength  : number=100;
  public townOrCityMaxLength: number=100;

  //#endregion 

  constructor(
    private addressesService     : AddressesService,
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private countriesService     : CountriesService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.formSubmitted =false;
      this.foundAddresses=false;
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(addressID: null | number | undefined): void {
    try {
      this.refreshCountryData();
      this.resetMainVariables();

      this.newAddress=addressID==null || addressID==undefined || addressID<=0;
      this.addressId =this.newAddress ? 0 : addressID;

      if (this.newAddress)
        this.openModal();
      else
        this.getAddressAndOpenModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.addressModalFormRef=this.modalService.open(this.addressModalForm, { backdrop: this.modalBackGround,
                                                                               centered: true,
                                                                               keyboard: false,
                                                                               size    : msSize.Medium });
    }
    catch(e) {
      this.addressFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formOfAddress() {
    return this.addressForm.controls;
  }
  
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.addressForm);

      this.addressForm=this.formBuilder.group({ });
            
      this.addFormFields(this.addressForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.addressForm) {
        this.addFormControl(formGroup, "countryId",      this.defaultCountryId, [Validators.required, Validators.maxLength(this.countyMaxLength)]);
        this.addFormControl(formGroup, "county",         "",                    [                     Validators.maxLength(this.countyMaxLength)]);
        this.addFormControl(formGroup, "line1",          "",                    [Validators.required, Validators.maxLength(this.line1MaxLength)]);
        this.addFormControl(formGroup, "line2",          "",                    [                     Validators.maxLength(this.line2MaxLength)]);
        this.addFormControl(formGroup, "line3",          "",                    [                     Validators.maxLength(this.line3MaxLength)]);
        this.addFormControl(formGroup, "postCode",       "",                    [Validators.required, Validators.maxLength(this.postCodeMaxLength)]);
        this.addFormControl(formGroup, "postcodeLookup", "",                    []);
        this.addFormControl(formGroup, "selectAddress",  undefined,             []);
        this.addFormControl(formGroup, "townOrCity",     "",                    [                     Validators.maxLength(this.townOrCityMaxLength)]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.addressForm && this.address != undefined) {
        this.setAddressControlValues(this.address);
       }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addressFormSubmit(): void {
    try {
      this.formSubmitted=true;

      if (this.addressForm.valid) {
        this.prepareToSaveAddress();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public addressFormCancel() {
    try {
      this.addressFormCancelled.emit();
      this.addressModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getAddressAndOpenModal() {
    try {
      this.addressesService.getById(<number>this.addressId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.address=data;

          this.populateFormFields(this.addressForm);
          this.openModal();
         },
        error: error => {
          this.addressFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region Dropdown Arrays
  
  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="countryId") {
        return this.countryIdData;
      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }
  
  public getDropdownDataObjectArrayForSelectAddress() {
    try {
      return this.selectedAddressData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }
  
  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="countryId") {
              this.countryIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="selectAddress") {
              this.selectedAddressData=(data as AddressDTO[])
              this.foundAddresses     =this.selectedAddressData.length>0;

              if (!this.foundAddresses) {
                this.warningModalForm.openForm("No Addresses Found", "For postcode " + this.addressForm.get("postcodeLookup")?.value.toUpperCase());
              }
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  //#region Refresh Dropdown Arrays Data
  
  public refreshCountryData() {
    try {
      this.getDropdownData(this.countriesService.getIdAndDescription(), "countryId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshPostcodeSearchAddresses(postcode: string) {
    try {
      this.getDropdownData(this.addressesService.getPostcodeSearchAddresses(postcode), "selectAddress");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  private prepareToSaveAddress() {
    try
    {
      this.address={
        countryID : this.addressForm.get("countryId")?.value,
        county    : this.addressForm.get("county")?.value,
        enteredBy : this.curUser.userId,
        id        : this.addressId ?? -1,
        line1     : this.addressForm.get("line1")?.value,
        line2     : this.addressForm.get("line2")?.value,
        line3     : this.addressForm.get("line3")?.value,
        postCode  : this.addressForm.get("postCode")?.value,
        townOrCity: this.addressForm.get("townOrCity")?.value
      };

      this.saveAddress(this.address)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (this.newAddress) {
            this.address!.id=data.id;
          }
          
          this.addressModalFormRef.close();
          this.dataHasBeenSaved.emit(this.address);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveAddress(address: AddressDTO): Observable<AddressDTO> {
    return this.addressesService.save(address);
  }

  public postcodeLookup(companyAddress: boolean) {
    try {
      this.addressForm.controls["selectAddress"].setValue(undefined);

      let searchPostCode: string=this.addressForm.get("postcodeLookup")?.value;

      if (searchPostCode==undefined || searchPostCode.trim()=="") {
        this.warningModalForm.openForm("Postcode not Submitted", "Please submit a postcode for an address search");
      
      } else {
        this.refreshPostcodeSearchAddresses(searchPostCode);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectAddressDropDownChange(e: any) {
    try {
      let address: AddressDTO | undefined=this.selectedAddressData.find(x => x.id==this.addressForm.get("selectAddress")?.value);
      
      if (address != undefined) {
        this.setAddressControlValues(address);
       }

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public setAddressControlValues(address: AddressDTO | undefined) {
    try {
      this.addressForm.controls["countryId"].setValue(address?.countryID);
      this.addressForm.controls["county"].setValue(address?.county);
      this.addressForm.controls["line1"].setValue(address?.line1);
      this.addressForm.controls["line2"].setValue(address?.line2);
      this.addressForm.controls["line3"].setValue(address?.line3);
      this.addressForm.controls["postCode"].setValue(address?.postCode);
      this.addressForm.controls["townOrCity"].setValue(address?.townOrCity);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
